import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=0479a848&scoped=true&"
import script from "./NotificationBell.vue?vue&type=script&lang=js&"
export * from "./NotificationBell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=0479a848&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0479a848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0479a848')) {
      api.createRecord('0479a848', component.options)
    } else {
      api.reload('0479a848', component.options)
    }
    module.hot.accept("./NotificationBell.vue?vue&type=template&id=0479a848&scoped=true&", function () {
      api.rerender('0479a848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/NotificationBell.vue"
export default component.exports